export default "__VITE_ASSET__BvNMzRyo__"